// extracted by mini-css-extract-plugin
export default {"wrapper":"Informations_wrapper__omIeb","content":"Informations_content__A1Sj2","content__cards":"Informations_content__cards__Opxvh"};